import {useCallback, useEffect, useRef, useState} from 'react'


export const useVisibilityChange = (onChange?: (visible: boolean) => void) => {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const handleVisibilityChange = () => {
      onChangeRef.current?.(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
};


export default function useAnimationFrame ({ 
    playing, interval, 
    onTimeChange 
  }: { playing: boolean; interval: number; onTimeChange: (cb: number) => void }) {
  const frameRef = useRef<number | null>(null);
  const lastFrameTime = useRef<number | null>(null);
  const onTimeChangeRef = useRef(onTimeChange);
  onTimeChangeRef.current = onTimeChange;

  useEffect(() => {
    const loop = (timestamp: number) => {
        if (lastFrameTime.current) {
            const delta = timestamp - lastFrameTime.current;
            if (delta >= interval) {
              onTimeChangeRef.current(delta);
              lastFrameTime.current = timestamp;
            }
        } else {
          lastFrameTime.current = timestamp;
        }
        frameRef.current = requestAnimationFrame(loop);
    }

    const cancel = () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
        frameRef.current = null;
        lastFrameTime.current = null;
      }
    }

    if (playing) {
        lastFrameTime.current = null;
        frameRef.current = requestAnimationFrame(loop);
        return cancel;
    } else {
      cancel();
    }
  }, [playing, interval]);
}